export const Padding = ({ size = "20px", children }) => {
  return <div style={{ padding: `${size}` }}>{children}</div>;
};
